
import { useContext } from '@nuxtjs/composition-api';
import useRoamingPrices from '~/composable/useRoaminPrices';


export default {
  setup () {
    const { app } = useContext()
    const {
      countries,
      toCountryModel,
      toCountryDisabled,
      paymentTypeItems,
      fromCountryDisabled,
      countryItems,
      getCountries
    } = useRoamingPrices(app)
    getCountries()
    return {
      countries,
      toCountryModel,
      countryItems,
      fromCountryDisabled,
      toCountryDisabled,
      paymentTypeItems
    }
  }
}
